import { render } from "./TotalEnrolled.vue?vue&type=template&id=f6c540c8&ts=true"
import script from "./TotalEnrolled.vue?vue&type=script&lang=ts"
export * from "./TotalEnrolled.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__